import { Component } from '@angular/core';
import { LoaderService } from '@app/servicios/loader.service';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  public loading: boolean = true;

  constructor(public loader: LoaderService) {
  }

}
